import { Model } from "@vuex-orm/core";
import config from "../configs/MeetingResolution";
import VotingCategory from "./VotingCategory";
import Majority from "./Majority";
import ResolutionVote from "./ResolutionVote";
import Media from "./Media";

export default class MeetingResolution extends Model {
  static get entity() {
    return "meeting_resolution";
  }
  // static get primaryKey() {
  //   return ["id" /* "meeting_id", "resolution_id" */];
  // }

  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      // ..
      meeting_id: this.attr(null),
      resolution_id: this.attr(null),
      // ..
      voting_category_id: this.attr(null),
      majority_id: this.attr(null),

      position: this.attr(null),
      resolution_number: this.attr(null),
      status: this.attr(null),
      created_during_meeting: this.attr(null),

      name: this.attr(null),
      slug: this.attr(null),
      description: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      resolution_for_reset: this.attr(null),

      // HACK: to order by voting category name
      voting_category: this.belongsTo(VotingCategory, "voting_category_id"),
      // HACK: to order by majority name
      majority: this.belongsTo(Majority, "majority_id"),
      // HACK: ..
      resolution_votes: this.hasMany(ResolutionVote, "meeting_has_resolution_id"),

      // media: this.hasMany(Media, "meeting_has_resolution_id"),
      media: this.attr(null),

      // ..
      parent_resolution_id: this.attr(null),
      children_resolutions: this.hasMany(MeetingResolution, "parent_resolution_id"),

      parent_resolution: this.belongsTo(MeetingResolution, "parent_resolution_id"),

      revote_majority_id: this.attr(null),
      revote_majority: this.belongsTo(Majority, "revote_majority_id"),
      // Has revote is only for local use
      has_revote: this.attr(null),
      // NOTE: old_revote_majority are only for local use
      old_revote_majority_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
